import React from 'react'
import {connect} from 'react-redux'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import Moment from 'react-moment'
import defaultSettings from '../../config/defaultSettings'
import {getRegionalDateFormat, getRegionalLocale} from 'selectors/settings'

const Date = (props) => {
  const {locale, dateFormat, children, date, ...otherProps} = props

  return isNil(date) && isNil(children)
      ? null
      : (
          <Moment
              locale={locale}
              format={dateFormat}
              date={date}
              {...otherProps}>
            {children}
          </Moment>
      )
}

Date.propTypes = {
  locale: propTypes.string,
  dateFormat: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.string,
    propTypes.instanceOf(Date),
    propTypes.object,
    propTypes.array,
    propTypes.number,
  ]),
  date: propTypes.oneOfType([
    propTypes.string,
    propTypes.instanceOf(Date),
    propTypes.object,
    propTypes.array,
    propTypes.number,
  ]),
}

Date.defaultProps = {
  locale: defaultSettings.locale,
  dateFormat: defaultSettings.dateFormat,
}

const mapStateToProps = (state, ownProps) => ({
  locale: getRegionalLocale(state),
  dateFormat: ownProps.dateFormat || getRegionalDateFormat(state),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Date)
